<nz-row [nzGutter]="[0, 8]">
  @for (profileDTO of profileDTOs; track profileDTO.username) {
    <nz-col>
      <nz-tag
        [nzMode]="'default'"
        [nzBordered]="false"
        [nzColor]="profileDTO.color"
        (click)="onTagClicked(profileDTO)"
        [class]="{ pointer: !!valuePublisher() }">
        &#64;{{ profileDTO.username }}
      </nz-tag>
    </nz-col>
  }
</nz-row>
